export enum ButtonMode {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Info = 'info',
}

export enum ButtonSize {
  Small = 'small',
  Big = 'big',
  Large = 'large',
}

export enum ButtonKind {
  Primary = 'primary',
  Ink = 'ink',
  Outline = 'outline',
  Ghost = 'ghost',
  Soft = 'soft',
  Danger = 'danger',
}
